module.exports = __webpack_public_path__ + "img/logo-vivo-vivinho.d0c9ffd1.svg";